// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

var home_page_link = {
  text: "Home",
  target: Config$PorterinUtils.oms_url
};

var uae = {
  text: "Home",
  target: Config$PorterinUtils.oms_url
};

var ind = {
  text: "Home",
  target: "https://www.porter.in"
};

var ban = {
  text: "Home",
  target: "https://www.porter.com.bd"
};

var tur = {
  text: "Home",
  target: "https://theporter.com.tr"
};

export {
  home_page_link ,
  uae ,
  ind ,
  ban ,
  tur ,
}
/* Config-PorterinUtils Not a pure module */
